import './MapExplanation.css'
import {IonContent} from "@ionic/react";
import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";

/**
 * Component displaying explanations about the map and its legend
 * @author Alizée Grand
 * @version 1.2
 * @creation 13/04/2021
 * @last_update 05/01/2022
 **/
class MapExplanation extends React.Component<WithTranslation>{
    render() {
        return (
            <IonContent color="primary" id="explanationContainer">
                <h1>
                    {this.props.t("pages.map.explanation.title")}
                </h1>
                <p>
                    {this.props.t("pages.map.explanation.content")}
                </p>
            </IonContent>
        );
    }
}

export default withTranslation()(MapExplanation);
